module.exports = __webpack_public_path__ + "static/slackAlpha.3edd66fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slackAlpha.png
// module id = 1166
// module chunks = 79611799117203